<template>
  <HomePage />
</template>

<script>
import HomePage from './components/Homepage.vue'
import "./style.css"

export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>

<style>
</style>
